var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class PushNotificationData extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.channel = '';
        /** @override */ this.item_id = 0;
        /** @override */ this.person_id = 0;
        /** @override */ this.tenant_id = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "booking_id", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], PushNotificationData.prototype, "channel", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "conversation_id", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "item_id", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "message_id", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "news_article_id", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "person_id", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], PushNotificationData.prototype, "tenant_id", void 0);
